import * as R from "ramda";

export const getCsvUrlWithTenantId = (data) => {
  const url = R.path(["payload", "csvUrl"], data);
  const tenantId = R.prop("tenantId", data);
  const [parsedUrl, params] = url.split("?");
  if (params) return `${parsedUrl}?${params}&tenantId=${tenantId}`;
  return `${parsedUrl}?tenantId=${tenantId}`;
};
